import { useContext } from 'react';
import { FunContext, FunContextType } from '../contexts/fun_context';

const useFun = () => {
    return useContext(FunContext) as FunContextType;
};

export default useFun;
